import jwt from 'jsonwebtoken';
import moment from 'moment';
import Cookies from 'universal-cookie';

import config from '../config';

const secret = config.auth.secretToken;

interface IUser {
  name: string;
  user_email: string;
  upn: string;
  oid: string;
  adapter: string;
  groups: string[];
  lastSignIn: any;
  passwordExpiryDate: any;
}

interface IJwtToken {
  header: { alg: string; typ: string };
  signature?: string;
}

interface IDecodedToken extends IJwtToken {
  payload: { exp: number; data: IUser; iat: number };
}

interface IDecodedAzureToken extends IJwtToken {
  payload: {
    aud: string;
    iss: string;
    iat: number;
    nbf: number;
    exp: number;
    aio: string;
    amr: string[];
    c_hash: string;
    email: string;
    family_name: string;
    given_name: string;
    ipaddr: string;
    name: string;
    nonce: string;
    oid: string;
    rh: string;
    sub: string;
    tid: string;
    unique_name: string;
    upn: string;
    uti: string;
    ver: string;
  };
}

export function sign(payload: IUser) {
  return jwt.sign(
    {
      exp: moment().add(config.auth.cookieTime, 'minutes').unix(),
      data: payload,
    },
    config.auth.secretToken,
  );
}

export function verify(token: string) {
  try {
    return jwt.verify(token, secret);
  } catch (err) {
    if (err instanceof Error) {
      throw new Error(err.message);
    }
    throw new Error('Token verification failed');
  }
}

export function decode(token: string) {
  // returns null if token is invalid
  const decodedToken = jwt.decode(token, { complete: true });

  return decodedToken;
}

export const getApiTokenFromCookie = (cookie?: any) => {
  const cookies = new Cookies(cookie);

  return cookies.get('token');
};

export const getTempIdFromCookie = (cookie?: any) => {
  const cookies = new Cookies(cookie);

  return cookies.get('tempId');
};

export const getUserFromToken = (cookie?: any) => {
  const apiToken = getApiTokenFromCookie(cookie);

  if (!apiToken) {
    return false;
  }

  const decodedToken = decode(apiToken);

  if (!decodedToken) {
    console.info('getUserFromToken: Token is invalid');

    return false;
  }

  const { payload } = decodedToken as IDecodedToken;

  return payload;
};

export type { IUser, IDecodedAzureToken, IDecodedToken };
